import Tariffs from './views/Tariffs.c';
export default Tariffs;
